
import TableList from "@components/templates/tablelist";
import { HttpGetshipmentAddressList,HttpDeleteshipmentAddressOne } from "@/service/managechannel/managechannel";
import { mapState,mapGetters } from "vuex";

import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpGetshipmentAddressList,
        interceptRequest(params){
            // console.log(params)
            delete params.search.createdAt;
            delete params.search.updatedAt;
            return params;
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'deliverychannelUpdate',
                        params: { type: "add" },
                        query: { id: params },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'deliverychannelUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title:this.$t('global.common.query',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        showFooter:false,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query'
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "deliverychannelUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                
                case "delete":
                    this.operate={
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        width: 'middle',
                        showDesc: false,
                        params: { id: params },
                        ajaxRequest: HttpDeleteshipmentAddressOne,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注"
                            }
                        ]
                    }
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/Salesperson/export',this.formData,'download');
                    break;

            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, active } = row
            return [{
                label:this.$t('global.common.query',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('global.common.edit',{defaultValue:'编辑'}),
                show:true,
                to: {
                    name: 'deliverychannelUpdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            },{
                label:this.$t('global.common.delete',{defaultValue:'删除'}),
                show:true,
                params:id,
                operate:'delete'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        // countryList
        ...mapGetters('diction',['getNewAccountIdList','getNewAccountType']),
        ...mapGetters('dictionary',['getCountryList']),
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t("global.common.add",{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
                // {
                //     name: this.$t("global.common.import",{defaultValue:'导入'}),
                //     operate: "export",
                //     theme: "success",
                //     // batch:true,
                // },
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            return  [
                {
                    label: this.$t("global.common.channel",{defaultValue:'渠道'}),
                    tag: 'Select',
                    key: 'EQ_channelId',
                    show:true,
                    class:'minSelect',
                    options: this.getNewAccountIdList,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: this.$t("erp.channelbase.channel_type",{defaultValue:'渠道类型'}),
                    tag: 'Select',
                    key: 'EQ_channelType',
                    show:true,
                    options: this.getNewAccountType,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: this.$t("erp.b2c.zip_code",{defaultValue:'邮编'}),
                    tag: 'vInput',
                    key: 'CN_zipCode',
                },

                {
                    label:this.$tc("global.common.country",1,{defaultValue:'国家'}),
                    tag: 'vSelect',
                    key: 'EQ_country',
                    options: this.getCountryList,
                    props:{
                        filterable:true,
                    }
                },

            ]
        },
        // table的展示数据
        columns() {
            return  [{
                title: this.$t("global.common.operation",{defaultValue:'操作'}),
                width: 90,
                render:this.getOperateNodes
            },
            {
                title: this.$t("erp.channelbase.channel_type",{defaultValue:'渠道类型'}),
                key: 'channelType',
            },

            {
                title: this.$t("erp.channelbase.channel_name",{defaultValue:'渠道名称'}),
                key: 'active',
                render: (h, { row }) => this.findRenderLabel(this.getNewAccountIdList, row.channelId)
            },
            {
                title: this.$t("erp.product.warehouse_information",{defaultValue:'发货信息'}),
                // key: 'warehouseCode',
                render:(h,{row})=>{
                    return <div>
                        <div>{row.address},{row.city},{row.state},{row.country}</div>
                        <div>{row.zipCode || '--'}</div>
                    </div>
                }
            },
            {
                title: this.$t("global.common.notes",{defaultValue:'备注'}),
                render:(h,{row})=>{
                    return <div>{row.remark || '--'}</div>
                }
            },
            {
                title: this.$t("global.common.created_updated",{defaultValue:'创建/更新时间'}),
                render:(h,{row})=>{
                    return <div>
                        <div>{row.createdAt}</div>
                        <div>{row.updatedAt}</div>
                    </div>
                }
            }
        ];
        },

    },

};
